import { BaseAuthStore, createApiClient } from "toptaal-shared"

let apiClientInstance: ReturnType<typeof createApiClient> | null = null

export function configureStudentsApi(config: {
  authStore: BaseAuthStore
  onLogout: () => void
  apiUrl: string
}) {
  apiClientInstance = createApiClient({
    ...config,
    skipRefreshPaths: [
      "/auth/request_magic_link",
      "/auth/login",
      "/auth/password_login",
    ],
  })
}

export function getApiClient() {
  if (!apiClientInstance) {
    throw new Error("Students API not configured")
  }

  return apiClientInstance
}
